import styled from '@emotion/styled'

export interface ProgressProps {
  /** 0..1 fraction complete. */
  value: number
  label?: string
}

// Progress is a tokenized linear progress bar (role=progressbar) for course
// completion, upload state, and dashboard meters (KAT-297).
export function Progress({ value, label }: ProgressProps) {
  const pct = Math.max(0, Math.min(1, value)) * 100
  return (
    <Track
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={Math.round(pct)}
      aria-label={label}
    >
      <Fill style={{ width: `${pct}%` }} />
    </Track>
  )
}

const Track = styled.div`
  width: 100%;
  height: 8px;
  background: var(--c-bg-sunk);
  border-radius: 999px;
  overflow: hidden;
`

const Fill = styled.div`
  height: 100%;
  background: var(--c-accent);
  border-radius: 999px;
  transition: width var(--d-base) var(--ease-standard);
`
